import { call, put, takeLatest, all } from 'redux-saga/effects';
import { IFetchEmailLogsPayload, types } from './types';
import { fetchEmailLogsSuccess, fetchEmailLogsFail, fetchEmailLogStatsSuccess, fetchEmailLogStatsFail } from './action';
import { api } from '../../configurations/api';
import { emailLogsUrl, emailLogStatsUrl } from '../../configurations/api/url';
import { httpRequest } from '../types';
import { SentryCapture } from '../../analytics/Sentry';
import { Action } from 'redux';
import { globalErrorHandler } from '../error/saga';

function* fetchEmailLogsSaga({
    payload,
    resolve,
    reject,
}: {
    payload: IFetchEmailLogsPayload;
    resolve?: (data: any) => void;
    reject?: (error: any) => void;
}): any {
    try {
        const queryParams = new URLSearchParams();
        if (payload.page) queryParams.append('page', String(payload.page));
        if (payload.limit) queryParams.append('limit', String(payload.limit));
        if (payload.searchTerm) queryParams.append('searchTerm', payload.searchTerm);
        if (payload.type) queryParams.append('type', payload.type);
        if (payload.opened !== undefined) queryParams.append('opened', String(payload.opened));
        if (payload.invalidAddress !== undefined) queryParams.append('invalidAddress', String(payload.invalidAddress));
        if (payload.startDate) queryParams.append('startDate', payload.startDate);
        if (payload.endDate) queryParams.append('endDate', payload.endDate);
        if (payload.sortBy) queryParams.append('sortBy', payload.sortBy);
        if (payload.sortOrder) queryParams.append('sortOrder', payload.sortOrder);

        const url = `${emailLogsUrl}?${queryParams.toString()}`;
        const response = yield call(api, url, httpRequest.GET, null, 0, 0);
        yield put(fetchEmailLogsSuccess(response));
        if (resolve) {
            resolve(response);
        }
    } catch (error: any) {
        SentryCapture(error, 'error');
        yield put(fetchEmailLogsFail(error));
        yield call(globalErrorHandler, error);
        if (reject) {
            reject(error);
        }
    }
}

function* fetchEmailLogStatsSaga({ payload }: { payload: { startDate?: string; endDate?: string } }): any {
    try {
        const queryParams = new URLSearchParams();
        if (payload.startDate) queryParams.append('startDate', payload.startDate);
        if (payload.endDate) queryParams.append('endDate', payload.endDate);

        const url = `${emailLogStatsUrl}?${queryParams.toString()}`;
        const response = yield call(api, url, httpRequest.GET, null, 0, 0);
        yield put(fetchEmailLogStatsSuccess(response.data));
    } catch (error: any) {
        SentryCapture(error, 'error');
        yield put(fetchEmailLogStatsFail(error));
        yield call(globalErrorHandler, error);
    }
}

interface FetchEmailLogsAction extends Action {
    payload: IFetchEmailLogsPayload;
    resolve?: (data: any) => void;
    reject?: (error: any) => void;
}

interface FetchEmailLogStatsAction extends Action {
    payload: { startDate?: string; endDate?: string };
}

export default function* emailLogsSaga() {
    yield all([
        takeLatest<FetchEmailLogsAction>(types.FETCH_EMAIL_LOGS, fetchEmailLogsSaga),
        takeLatest<FetchEmailLogStatsAction>(types.FETCH_EMAIL_LOG_STATS, fetchEmailLogStatsSaga),
    ]);
}
